import { twMerge } from "tailwind-merge";

export const PageIndicator = ({
  pageLength,
  activePageIndex,
}: {
  pageLength: number;
  activePageIndex: number;
}) => {
  const numberPages = new Array(pageLength).fill("");
  return (
    <>
      <div className="flex gap-2">
        {numberPages.map((item, i) => (
          <span
            key={i}
            className={twMerge(
              "flex h-2 w-2 rounded-full bg-zinc-300",
              i === activePageIndex && "bg-zinc-700",
            )}
          ></span>
        ))}
      </div>
    </>
  );
};
